// extracted by mini-css-extract-plugin
export default {"tabulateButton":"PGxrZYMIBCb2t_AnFimI"};